module.exports = __webpack_public_path__ + "img/Case_Study_Image_2.e6604c7d.jpg";